/*
 * @overview: SDK参数配置文件
 * @Created by: zhuyikai
 * @Copyright: Copyright © 2020 找我婚礼. All rights reserved.
 * @Date: 2023-03-29 16:05:41
 */

export class Options {
  constructor() {
    this.api = ""; // 监控上报地址
    this.method = "GET"; // 请求方式
    this.use = true; // 是否开启监控
    this.projectName = ""; // 项目唯一key
    this.whiteList = []; // 拦截接口白名单
    this.apiSending = 0;
    this.projectAccessUrl = ""; // 项目访问统计地址
    this.useProjectAccess = true; // 是否开启项目统计
    this.useAutoAccess = true; // 是否开启自动上报
  }
  async bindOption(options = {}) {
    const {
      use,
      projectName,
      host,
      domain,
      whiteList,
      projectAccessUrl,
      useProjectAccess,
      useAutoAccess,
    } = options;
    this.api = `https://${domain}.${host}/logstores/${projectName}/track`; // 监控上报地址
    this.use = use;
    this.projectName = projectName;
    this.projectAccessUrl = projectAccessUrl;
    this.useProjectAccess = useProjectAccess;
    this.useAutoAccess = useAutoAccess || false;
    this.whiteList = [
      "/online-release/wallet/v1/getServerRelease",
      "/online-release/wallet/v1/getSystemNotice",
      `/logstores/${projectName}/track`,
    ];
    if (whiteList && whiteList.length) {
      this.whiteList = whiteList.concat([
        "/online-release/wallet/v1/getServerRelease",
        "/online-release/wallet/v1/getSystemNotice",
        `/logstores/${projectName}/track`,
      ]);
    }
  }
}

/**
 * 绑定配置参数
 */
const options = new Options();
export const initOptions = (paramsOption = {}) => {
  return new Promise((resolve, reject) => {
    options.bindOption(paramsOption);
    resolve();
  });
};

export { options };
